import React, {PropTypes} from 'react';
let logo = require('./logo_gray_filled.svg');

const HeaderImage = ({headerLink}) => {
  headerLink;
  // const savingsExist = NumberFormatter.scrubFormatting(savings.monthly) > 0;
  // const savingsClass = savingsExist ? 'savings' : 'loss';
  // const resultLabel = savingsExist ? 'Savings' : 'Loss';
  let panelHeaderImage = {
    backgroundImage: "url('"+(headerLink || logo)+"')"
  };
  return (
    <div className="image-header" style={panelHeaderImage} />
  );
};

// Note that this odd style is utilized for propType validation for now. Must be defined *after*
// the component is defined, which is why it's separate and down here.
HeaderImage.propTypes = {
  headerLink: PropTypes.string,
};

export default HeaderImage;



/** WEBPACK FOOTER **
 ** ./src/components/common/HeaderImage.js
 **/